export const LOCALE_NAME_SPACES = {
  APIS: "Apis",
  COMPLEX_COMPONENTS: "ComplexComponents",
  COMPONENTS: "Components",
  UTILS: "Utils",
  WRAPPER: "Wrapper",
} as const;

export const LOCALES = {
  EN: "en",
  FA: "fa",
} as const;
